"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisuallyHidden = void 0;
var visually_hidden_1 = require("./visually-hidden");
Object.defineProperty(exports, "VisuallyHidden", { enumerable: true, get: function () { return __importDefault(visually_hidden_1).default; } });
